import { logoutUser } from 'redux/reducers/user';
export const logout = () => {
  return (dispatch) => {
    dispatch(logoutUser());
  };
};
